export default __webpack_public_path__ + "static/media/wave.b97fc1db.svg";